import { useAtom } from 'jotai';
import { upmarketDataAtom } from '@fiverr-private/seller_pages_toolbox';

export const useUpmarketBannerVisibility = () => {
    const [upmarketData] = useAtom(upmarketDataAtom);
    const { segment: upmarketSegment } = upmarketData;

    return {
        withDesBanner: upmarketSegment?.proBuType === 'MPFit',
        withMultiBanner: upmarketSegment?.proBuType === 'ProFit',
    };
};
